import React, { useState } from "react";
import {
  AdvSeparator,
  Button,
  Chip,
  DetailCard,
  InfoTextAdv,
} from "../../../../../components";

const DetailCardList = () => {
  return (
    <div>
      <div className="grid grid-cols-3 gap-5 m-4">
        <div>
          <DetailCard
            title={
              <div>
                <h6 className="line-clamp-1">MOHR Test and Measurement LLC</h6>
              </div>
            }
            headeRight={
              <div className="mr-2">
                <Button icon={"add"} type="icon" size="sm" />
              </div>
            }
          >
            <AdvSeparator gap="gap-5">
              <InfoTextAdv
                title={"Created On"}
                titleProps={{ className: "!text-black" }}
                value={
                  <h5 className="line-clamp-1 text-black">July 8, 2024</h5>
                }
              />
              <InfoTextAdv
                title={"Last Used"}
                titleProps={{ className: "!text-black" }}
                value={
                  <h5 className="line-clamp-1 text-black">October 9, 2024</h5>
                }
              />
              <InfoTextAdv
                title={"Modified On"}
                titleProps={{ className: "!text-black" }}
                value={
                  <h5 className="line-clamp-1 text-black">July 8, 2024</h5>
                }
              />
            </AdvSeparator>
          </DetailCard>
        </div>
        <div>
          <DetailCard
            title={
              <div>
                <h6 className="line-clamp-1">MOHR Test and Measurement LLC</h6>
              </div>
            }
            headeRight={
              <div className="mr-2">
                <Button icon={"add"} type="icon" size="sm" />
              </div>
            }
          >
            <div className="flex justify-between items-center">
              <div>https://testinc.com</div>
              <div>
                <Chip
                  label="Civil Engineering"
                  color="invoiced"
                  className="!rounded-full"
                />
              </div>
            </div>
          </DetailCard>
        </div>
        {/* <DetailCard title="This is a string title">
          a dfabsdfo yabsdop fabsdfy asdfyasdf oy{" "}
        </DetailCard> */}
        <div>
          <DetailCard
            size="xs"
            title={
              <div className="flex items-center gap-2">
                <span class="material-symbols-outlined !text-lg">
                  alarm_add
                </span>
                <div className="font-bold text-xs">
                  Tue, 28/Mar/2025 21:40:20 PM
                </div>
              </div>
            }
            headeRight={
              <div>
                <Button
                  icon={"edit_square"}
                  variant="text"
                  type="icon"
                  size="sm"
                  color="black"
                />
              </div>
            }
          >
            <div className="my-2 mx-1 text-sm">
              (Inspector or Inspection or Inspecting) and (Construction or
              Civil) and (Transportation or Bridge or “Complex Category 2” or
              “CC2”)
            </div>
          </DetailCard>
        </div>
        <div>
          <DetailCard
            size="xs"
            color="white"
            className={"bg-primary-50"}
            title={
              <div className="flex items-center gap-2">
                <span class="material-symbols-outlined !text-lg">
                  alarm_add
                </span>
                <div className="font-bold text-xs">
                  Tue, 28/Mar/2025 21:40:20 PM
                </div>
              </div>
            }
            headeRight={
              <div>
                <Button
                  icon={"edit_square"}
                  variant="text"
                  type="icon"
                  size="sm"
                  color="black"
                />
              </div>
            }
          >
            <div className="py-2 px-1 text-sm ">
              (Inspector or Inspection or Inspecting) and (Construction or
              Civil) and (Transportation or Bridge or “Complex Category 2” or
              “CC2”)
            </div>
          </DetailCard>
        </div>
      </div>
    </div>
  );
};

export default DetailCardList;
